<div class="g-0">
    <div class="col">
        <div class="box-wrapper box-actualizare">
            <div class="box-content-header box-content-header-actualizare">
                <div class="row p-1">
                    <div class="col">
                        <mat-card-title>
                            <i class="fa-regular fa-pen-to-square"></i>
                            <span>Actualizare cerere</span>
                        </mat-card-title>
                    </div>
                </div>
            </div>
            <div class="box-content-body">
                <div class="col p-2 d-flex justify-content-start">
                    <div>
                        <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                            (change)="onActionChange($event)" value="status">
                            <mat-button-toggle
                                *ngIf="permissionsService.hasPermission('dgitl-module.solicitari.view.actualizare-status')"
                                value="status">
                                Status
                            </mat-button-toggle>

                            <mat-button-toggle
                                *ngIf="permissionsService.hasPermission('dgitl-module.solicitari.view.escaladare')"
                                value="escaladare">
                                Escaladare
                            </mat-button-toggle>

                            <mat-button-toggle
                                *ngIf="permissionsService.hasPermission('dgitl-module.solicitari.view.actualizare-prioritate')"
                                value="prioritate">
                                Prioritate
                            </mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                </div>
                <div class="row">
                    <div class="col" *ngIf="selectedActionToggle == 'status'">
                        <div
                            *ngIf="permissionsService.hasPermission('dgitl-module.solicitari.view.actualizare-status')">
                            <form [formGroup]="sendUpdateStatusForm" (ngSubmit)="submitUpdateStatusMessage()">
                                <div class="row p-1">
                                    <div class="col">
                                        <mat-form-field class="w-100" appearance="fill">
                                            <mat-label>Status</mat-label>
                                            <mat-select formControlName="current_status">
                                                <mat-option *ngFor="let row of statusCerere" [value]="row.id">
                                                    {{ row.name }}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error>Selectați un status</mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row p-1">
                                    <div class="col">
                                        <div class="fw-bold">Detalii</div>
                                        <angular-editor formControlName="message"
                                            [config]="editorConfig"></angular-editor>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <div class="col d-flex justify-content-end">
                                            <button [disabled]="sendUpdateStatusForm.invalid"
                                                class="btn btn-light upload-btn m-3" type="submit">
                                                <span class="upload__text">TRIMITE</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="col" *ngIf="selectedActionToggle == 'prioritate'">
                        <div
                            *ngIf="permissionsService.hasPermission('dgitl-module.solicitari.view.actualizare-prioritate')">
                            <form [formGroup]="sendUpdatePriorityForm" (ngSubmit)="submitUpdatePriorityMessage()">
                                <div class="row p-1">
                                    <div class="col">
                                        <mat-form-field class="w-100" appearance="fill">
                                            <mat-label>Prioritate</mat-label>
                                            <mat-select formControlName="id_cerere_priority">
                                                <mat-option *ngFor="let row of prioritateCerere" [value]="row.id">
                                                    {{ row.name }}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error>Selectați o prioritate</mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row p-1">
                                    <div class="col">
                                        <div class="fw-bold">Detalii</div>
                                        <angular-editor formControlName="message"
                                            [config]="editorConfig"></angular-editor>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="col d-flex justify-content-end">
                                            <button [disabled]="sendUpdatePriorityForm.invalid"
                                                class="btn btn-light upload-btn m-3" type="submit">
                                                <span class="upload__text">TRIMITE</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="col" *ngIf="selectedActionToggle == 'escaladare'">
                        <div *ngIf="permissionsService.hasPermission('dgitl-module.solicitari.view.escaladare')">
                            <form [formGroup]="sendUpdateAssigneeForm" (ngSubmit)="submitUpdateAssigneeMessage()">
                                <div class="row p-1">
                                    <div class="col">
                                        <mat-form-field class="w-100">
                                            <mat-label>Compartiment/Birou/Serviciu</mat-label>
                                            <mat-select formControlName="id_compartiment"
                                                (openedChange)="onCompartimentSelectClosed()"
                                                (selectionChange)="onCompartimentChange($event.value)">
                                                <mat-form-field class="px-2 w-100 sticky-input">
                                                    <input matInput [formControl]="compartimenteControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field>

                                                <mat-option
                                                    *ngIf="filteredCompartimente.length === 0 && compartimenteControl.value"
                                                    disabled>
                                                    <span>No results found</span>
                                                </mat-option>

                                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                                <mat-option *ngFor="let departament of filteredCompartimente"
                                                    [value]="departament.id_compartiment">
                                                    {{ departament.name }}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error
                                                *ngIf="!sendUpdateAssigneeForm.controls['id_compartiment'].valid && sendUpdateAssigneeForm.controls['id_compartiment'].touched">
                                                Câmp obligatoriu
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row p-1">
                                    <div class="col">
                                        <mat-form-field appearance="fill" class="w-100">
                                            <mat-label>Operator</mat-label>
                                            <mat-select (openedChange)="onUsersSelectClosed()"
                                                formControlName="id_user_assigned">
                                                <mat-form-field class="px-2 w-100 sticky-input">
                                                    <input matInput [formControl]="usersControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field>

                                                <mat-option *ngIf="filteredUsers.length === 0 && usersControl.value"
                                                    disabled>
                                                    <span>No results found</span>
                                                </mat-option>

                                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                                <mat-option *ngFor="let user of filteredUsers" [value]="user.id">
                                                    {{ user.name }}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error
                                                *ngIf="!sendUpdateAssigneeForm.controls['id_user_assigned'].valid && sendUpdateAssigneeForm.controls['id_user_assigned'].touched">
                                                Câmp obligatoriu
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row p-1">
                                    <div class="col">
                                        <div class="fw-bold">Detalii</div>
                                        <angular-editor formControlName="content"
                                            [config]="editorConfig"></angular-editor>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <div class="col d-flex justify-content-end">
                                            <button [disabled]="sendUpdateAssigneeForm.invalid"
                                                class="btn btn-light upload-btn m-3" type="submit">
                                                <span class="upload__text">TRIMITE</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section-spinner position-fixed" *ngIf="isLoading">
                <div class="spinner position-absolute top-50 start-50 translate-middle">
                    <mat-spinner></mat-spinner>
                    <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                </div>
            </div>
        </div>
    </div>
</div>